import { Component, OnInit } from '@angular/core';
import { QuotationHistoryService, Quotation } from "app/services/quotation-history.service";
import { CompanyService, Company } from "app/services/company.service";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService, User } from "app/services/user.service";


@Component({
    selector: 'app-quotation-history-single',
    templateUrl: './quotation-history-single.component.html',
    styleUrls: ['./quotation-history-single.component.css']
})
export class QuotationHistorySingleComponent implements OnInit {
    user_uuid: string;
    quotation_key: string;
    print_key: string;
    quotation: any;
    companies: Company[];
    quotation_product_list: any;
    cat_assoc = {};
    company;
    user: any;
    k = {
        'city': '',
        'name': '',
        'full_address': '',
        'tel': '',
        'fax': ''
    };
    ind;
    reg;
    eng;


    constructor(
        private quotationHistoryService: QuotationHistoryService,
        private companyService: CompanyService,
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.user_uuid = this.route.snapshot.params['id'];
        this.quotation_key = this.route.snapshot.params['quote_key'];
        this.print_key = this.route.snapshot.params['print_key']
        if(this.quotation_key){
            this.quotationHistoryService.getSingleQuotation(this.quotation_key).subscribe(data => {
                this.quotation = data
                console.log(data.list)
                console.log(data.showPosition)
                if(data.list){
                    this.quotation_product_list = Object.keys(data.list).map(id => {
                        return data.list[id];
                    })
                    console.log(this.quotation_product_list)
                }
            });

            this.userService.getUser(this.user_uuid).subscribe(user => {
                this.user = user;
            })
            this.template();
        }
        if (this.print_key) {
            this.quotationHistoryService.getSingleQuotation(this.print_key).subscribe(data => {
                this.quotation = data;
                if(data.list){
                    this.quotation_product_list = Object.keys(data.list).map(id => {
                        return data.list[id];
                    })
                }
            })
            this.userService.getUser(this.user_uuid).subscribe(user => {
                this.user = user;
            })
            this.companyService.getCompanies().subscribe(companies => {
                this.companies = companies;
                companies.forEach((company, i) => {
                    this.cat_assoc[company.$key] = company;
                })
            })
            this.template();
        }
    }

    template() {
        if (this.quotation.template == 'Regional - IND') {
            this.ind = '';
            this.eng = '';
            this.reg = 'true';
            this.k.name = 'PT. Indesso Aroma';
            this.k.full_address = 'Jl. Tanah Abang 2 No. 78, Jakarta 10150 – Indonesia | Tel. +62-21-3863974 | Fax +62-21-3851864';
            this.k.city = 'Jakarta';
        }
        if (this.quotation.template == 'Regional - MAL') {
            this.ind = '';
            this.eng = '';
            this.reg = 'true';
            this.k.name = 'Indesso Malaysia Sdn Bhd';
            this.k.tel = ' Tel. +603-22024073';
            this.k.fax = 'Fax +603-22024001';
            this.k.full_address = 'Suite 8,01 8th floor, Menara IGB, Mid Valley City, Lingkaran Syeh Putra, Kuala Lumpur 59200 , Malaysia';
            this.k.city = 'Malaysia';
        }
        if (this.quotation.template == 'Domestic Jakarta - IND') {
            this.reg = '';
            this.eng = '';
            this.ind = 'true';
            this.k.name = 'PT. Indesso Niagatama';
            this.k.full_address = 'Jl. Tanah Abang 2 No. 78, Jakarta 10150 – Indonesia | Tel. +62-21-3863974 | Fax +62-21-3851864';
            this.k.city = 'Jakarta';
        }
        if (this.quotation.template == 'Domestic Semarang - IND') {
            this.reg = '';
            this.eng = '';
            this.ind = 'true';
            this.k.name = 'Indesso Semarang Branch';
            this.k.full_address = 'Jl. Halmahera Raya No. 53, Semarang 50125 – Indonesia | Tel. +62-24-8416071 | Fax +62-24-8316521';
            this.k.city = 'Semarang';
        }
        if (this.quotation.template == 'Domestic Semarang - IND') {
            this.reg = '';
            this.eng = '';
            this.ind = 'true';
            this.k.name = 'Indesso Semarang Branch';
            this.k.full_address = 'Jl. Halmahera Raya No. 53, Semarang 50125 – Indonesia | Tel. +62-24-8416071 | Fax +62-24-8316521';
            this.k.city = 'Semarang';
        }
        if (this.quotation.template == 'Domestic Surabaya - IND') {
            this.reg = '';
            this.eng = '';
            this.ind = 'true';
            this.k.name = 'Indesso Surabaya Branch';
            this.k.full_address = 'Jl. Jemusari Raya No. 264 , Surabaya 60299 – Indonesia | Tel. +62-31-8419886 | Fax +62-31-8434811';
            this.k.city = 'Surabaya';
        }
        if (this.quotation.template == 'Domestic Jakarta - ENG') {
            this.reg = '';
            this.eng = 'true';
            this.ind = '';
            this.k.name = 'PT. Indesso Niagatama';
            this.k.full_address = 'Jl. Tanah Abang 2 No. 78, Jakarta 10150 – Indonesia | Tel. +62-21-3863974 | Fax +62-21-3851864';
            this.k.city = 'Jakarta';
        }
        if (this.quotation.template == 'Domestic Semarang - ENG') {
            this.reg = '';
            this.eng = 'true';
            this.ind = '';
            this.k.name = 'Indesso Semarang Branch';
            this.k.full_address = 'Jl. Halmahera Raya No. 53, Semarang 50125 – Indonesia | Tel. +62-24-8416071 | Fax +62-24-8316521';
            this.k.city = 'Semarang';
        }
        if (this.quotation.template == 'Domestic Surabaya - ENG') {
            this.reg = '';
            this.eng = 'true';
            this.ind = '';
            this.k.name = 'Indesso Surabaya Branch';
            this.k.full_address = 'Jl. Jemusari Raya No. 264 , Surabaya 60299 – Indonesia | Tel. +62-31-8419886 | Fax +62-31-8434811';
            this.k.city = 'Surabaya';
        }
    }

    print(name) {
        window.print();
    }
    goBack() {
        window.history.back();
    }
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/quotation/quotation-history-single/quotation-history-single.component.ts